import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { ValidationErrorComponent } from './validation-error/validation-error.component';
import { ConfirmDialogComponent } from './components/confirmation-dialog/confirmation-dialog.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        RouterModule
    ],
    exports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        RouterModule,
        ValidationErrorComponent,
        ConfirmDialogComponent
    ],
    declarations: [
        ValidationErrorComponent,
        ConfirmDialogComponent
    ]
})
export class SharedModule {
}